import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import { useLanguage } from "../../context/LanguageContext";
import { usePublicConfigValue } from "../../hooks/usePublicConfig";

/**
 * Footer — full-width, single centred line of links separated by pipes.
 */
export default function Footer() {
  const { t } = useLanguage();
  const publicConfig = usePublicConfigValue();
  const siteName =
    `${
      publicConfig?.branding?.siteName ||
      publicConfig?.general?.siteName ||
      publicConfig?.platformBranding?.siteName ||
      ""
    }`.trim() ||
    "Uniflo";
  const supportEmail =
    `${publicConfig?.general?.siteEmail || publicConfig?.tenant?.supportEmail || publicConfig?.platformBranding?.supportEmail || ""}`.trim() ||
    "support@uniflo.app";
  const internalLinks = [
    { label: t("footer_marketing", "Marketing Site"), to: "/" },
    { label: t("footer_pricing", "Pricing"), to: "/pricing" },
    { label: t("footer_create_clan", "Create Workspace"), to: "/get-started" },
    { label: t("footer_account", "Your Account"), to: "/account" },
    { label: t("footer_privacy", "Privacy"), to: "/site/privacy" },
    { label: t("footer_terms", "Terms"), to: "/site/terms" },
    { label: t("footer_platform_admin", "Platform Admin"), to: "/app/login" },
  ];
  const externalLinks = [
    {
      label: t("footer_support", "Support"),
      href: `mailto:${supportEmail}`,
      ariaLabel: t("footer_support", "Support"),
    },
  ];

  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.inner}>
        <span className={styles.copyright}>
          &copy; COPYRIGHT {siteName.toUpperCase()}
        </span>

        {internalLinks.map((link) => (
          <React.Fragment key={link.to}>
            <span className={styles.separator} aria-hidden="true">|</span>
            <Link to={link.to} className={styles.link}>
              {link.label}
            </Link>
          </React.Fragment>
        ))}

        {externalLinks.map((link) => (
          <React.Fragment key={link.label}>
            <span className={styles.separator} aria-hidden="true">|</span>
            <a
              href={link.href}
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.ariaLabel}
            >
              {link.label}
            </a>
          </React.Fragment>
        ))}
      </div>
    </footer>
  );
}
